/**
 * @module Services/Bff/Presenters/Order
 * @desc Order Presenter
 *
 */

import { Order, SHIPPING_MODEL } from 'core/domains';
import { formatDate, formatMoney } from 'core/utilities';

import type { OrderResponse } from '../../@types';

/**
 * Returns the formatted order details information from BFF to the store
 *
 */
export function orderPresenter({ data }: OrderResponse): Order['data'] {
  const { deliveryAddress, deliveryDate, id, paymentAmount, payments = [], status } = data;

  return {
    code: id,
    deliveryDate: formatDate(deliveryDate || ''),
    payments: payments.map((payment) => ({
      amount: formatMoney(payment.amount),
      amountNum: payment.amount,
      code: payment.id,
      dueDate: payment.dueDate ? formatDate(payment.dueDate) : '',
      installments: payment.installments,
      link: payment.link,
      name: payment.name,
      type: payment.type,
    })),
    paymentAmount: formatMoney(paymentAmount),
    paymentMethod: payments[0]?.type || '',
    status,
    shippingModel: {
      fullAddress: deliveryAddress?.fullAddress || '',
      shippingModelCode:
        deliveryAddress?.deliveryMode === 'takeaway'
          ? SHIPPING_MODEL.PICKUP_STORE
          : SHIPPING_MODEL.RESELLER,
    },
  };
}
